/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../../asyncapi/models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../../asyncapi/models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiCorrelationId } from '../../asyncapi/models/AaiCorrelationId';
import { AaiHeaderItem } from '../../asyncapi/models/AaiHeaderItem';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { AaiMessageBindings } from '../../asyncapi/models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../../asyncapi/models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../../asyncapi/models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../../asyncapi/models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../../asyncapi/models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../../asyncapi/models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../../asyncapi/models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../../asyncapi/models/AaiOperationTraitDefinition';
import { AaiParameter } from '../../asyncapi/models/AaiParameter';
import { AaiServerBindings } from '../../asyncapi/models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../../asyncapi/models/AaiServerBindingsDefinition';
import { IAai20Visitor } from '../../asyncapi/v2/visitors/IAai20Visitor';
import { Document } from '../../core/models/Document';
import { Extension } from '../../core/models/Extension';
import { Node } from '../../core/models/Node';
import { ValidationProblem } from '../../core/models/ValidationProblem';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { Contact } from '../../core/models/common/Contact';
import { ExternalDocumentation } from '../../core/models/common/ExternalDocumentation';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IExample } from '../../core/models/common/IExample';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { Info } from '../../core/models/common/Info';
import { License } from '../../core/models/common/License';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { Operation } from '../../core/models/common/Operation';
import { Parameter } from '../../core/models/common/Parameter';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { Schema } from '../../core/models/common/Schema';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { Tag } from '../../core/models/common/Tag';
import { IOasPropertySchema } from '../../openapi/models/IOasPropertySchema';
import { OasHeader } from '../../openapi/models/OasHeader';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { OasPaths } from '../../openapi/models/OasPaths';
import { OasResponse } from '../../openapi/models/OasResponse';
import { OasResponses } from '../../openapi/models/OasResponses';
import { OasSchema } from '../../openapi/models/OasSchema';
import { OasXML } from '../../openapi/models/OasXML';
import { Oas20Definitions } from '../../openapi/v2/models/Oas20Definitions';
import { Oas20Headers } from '../../openapi/v2/models/Oas20Headers';
import { Oas20Items } from '../../openapi/v2/models/Oas20Items';
import { Oas20ParameterDefinitions } from '../../openapi/v2/models/Oas20ParameterDefinitions';
import { Oas20ResponseDefinitions } from '../../openapi/v2/models/Oas20ResponseDefinitions';
import { Oas20Scopes } from '../../openapi/v2/models/Oas20Scopes';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { IOas20Visitor } from '../../openapi/v2/visitors/IOas20Visitor';
import { Oas30Callback } from '../../openapi/v3/models/Oas30Callback';
import { Oas30CallbackDefinition } from '../../openapi/v3/models/Oas30CallbackDefinition';
import { Oas30CallbackPathItem } from '../../openapi/v3/models/Oas30CallbackPathItem';
import { Oas30Discriminator } from '../../openapi/v3/models/Oas30Discriminator';
import { Oas30Encoding } from '../../openapi/v3/models/Oas30Encoding';
import { Oas30ExampleDefinition } from '../../openapi/v3/models/Oas30ExampleDefinition';
import { Oas30HeaderDefinition } from '../../openapi/v3/models/Oas30HeaderDefinition';
import { Oas30Link } from '../../openapi/v3/models/Oas30Link';
import { Oas30LinkDefinition } from '../../openapi/v3/models/Oas30LinkDefinition';
import { Oas30LinkParameterExpression } from '../../openapi/v3/models/Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from '../../openapi/v3/models/Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from '../../openapi/v3/models/Oas30LinkServer';
import { Oas30MediaType } from '../../openapi/v3/models/Oas30MediaType';
import { Oas30RequestBody } from '../../openapi/v3/models/Oas30RequestBody';
import { Oas30RequestBodyDefinition } from '../../openapi/v3/models/Oas30RequestBodyDefinition';
import { IOas30Visitor } from '../../openapi/v3/visitors/IOas30Visitor';

/**
 * This is an "All Node Visitor" that can be used as a base class for interesting visitors that wish
 * to visit every node in all data models.  This would work for OpenAPI 2, 3 and AsyncAPI data models.
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 */
export class CombinedAllNodeVisitor implements IOas20Visitor, IOas30Visitor, IAai20Visitor {
    /**
     * Visit a node.  This is a common method called for every node type.
     * @param {Node} node
     */
    visitNode(node : Node) {
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.openapi.models.IOasPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IOasPropertySchema) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServer(io.apicurio.datamodels.core.models.common.Server)
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitServerVariable(io.apicurio.datamodels.core.models.common.ServerVariable)
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitItems(io.apicurio.datamodels.openapi.v2.models.Oas20Items)
     * @param {Oas20Items} node
     */
    public visitItems(node : Oas20Items) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitScopes(io.apicurio.datamodels.openapi.v2.models.Oas20Scopes)
     * @param {Oas20Scopes} node
     */
    public visitScopes(node : Oas20Scopes) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitSecurityDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions)
     * @param {Oas20SecurityDefinitions} node
     */
    public visitSecurityDefinitions(node : Oas20SecurityDefinitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20Definitions)
     * @param {Oas20Definitions} node
     */
    public visitDefinitions(node : Oas20Definitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitParameterDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ParameterDefinitions)
     * @param {Oas20ParameterDefinitions} node
     */
    public visitParameterDefinitions(node : Oas20ParameterDefinitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitHeaders(io.apicurio.datamodels.openapi.v2.models.Oas20Headers)
     * @param {Oas20Headers} node
     */
    public visitHeaders(node : Oas20Headers) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor#visitResponseDefinitions(io.apicurio.datamodels.openapi.v2.models.Oas20ResponseDefinitions)
     * @param {Oas20ResponseDefinitions} node
     */
    public visitResponseDefinitions(node : Oas20ResponseDefinitions) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitComponents(io.apicurio.datamodels.core.models.common.Components)
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackPathItem(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackPathItem)
     * @param {Oas30CallbackPathItem} node
     */
    public visitCallbackPathItem(node : Oas30CallbackPathItem) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallback(io.apicurio.datamodels.openapi.v3.models.Oas30Callback)
     * @param {Oas30Callback} node
     */
    public visitCallback(node : Oas30Callback) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkServer(io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer)
     * @param {Oas30LinkServer} node
     */
    public visitLinkServer(node : Oas30LinkServer) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitCallbackDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30CallbackDefinition)
     * @param {Oas30CallbackDefinition} node
     */
    public visitCallbackDefinition(node : Oas30CallbackDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLink(io.apicurio.datamodels.openapi.v3.models.Oas30Link)
     * @param {Oas30Link} node
     */
    public visitLink(node : Oas30Link) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkRequestBodyExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkRequestBodyExpression)
     * @param {Oas30LinkRequestBodyExpression} node
     */
    public visitLinkRequestBodyExpression(node : Oas30LinkRequestBodyExpression) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkParameterExpression(io.apicurio.datamodels.openapi.v3.models.Oas30LinkParameterExpression)
     * @param {Oas30LinkParameterExpression} node
     */
    public visitLinkParameterExpression(node : Oas30LinkParameterExpression) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitLinkDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30LinkDefinition)
     * @param {Oas30LinkDefinition} node
     */
    public visitLinkDefinition(node : Oas30LinkDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitEncoding(io.apicurio.datamodels.openapi.v3.models.Oas30Encoding)
     * @param {Oas30Encoding} node
     */
    public visitEncoding(node : Oas30Encoding) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitMediaType(io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {Oas30MediaType} node
     */
    public visitMediaType(node : Oas30MediaType) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitHeaderDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30HeaderDefinition)
     * @param {Oas30HeaderDefinition} node
     */
    public visitHeaderDefinition(node : Oas30HeaderDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBody(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBody)
     * @param {Oas30RequestBody} node
     */
    public visitRequestBody(node : Oas30RequestBody) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitRequestBodyDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30RequestBodyDefinition)
     * @param {Oas30RequestBodyDefinition} node
     */
    public visitRequestBodyDefinition(node : Oas30RequestBodyDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitExampleDefinition(io.apicurio.datamodels.openapi.v3.models.Oas30ExampleDefinition)
     * @param {Oas30ExampleDefinition} node
     */
    public visitExampleDefinition(node : Oas30ExampleDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitDiscriminator(io.apicurio.datamodels.openapi.v3.models.Oas30Discriminator)
     * @param {Oas30Discriminator} node
     */
    public visitDiscriminator(node : Oas30Discriminator) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitNotSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30NotSchema)
     * @param {Oas30Schema.Oas30NotSchema} node
     */
    public visitNotSchema(node : Oas30Schema.Oas30NotSchema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitOneOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30OneOfSchema)
     * @param {Oas30Schema.Oas30OneOfSchema} node
     */
    public visitOneOfSchema(node : Oas30Schema.Oas30OneOfSchema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor#visitAnyOfSchema(io.apicurio.datamodels.openapi.v3.models.Oas30Schema.Oas30AnyOfSchema)
     * @param {Oas30Schema.Oas30AnyOfSchema} node
     */
    public visitAnyOfSchema(node : Oas30Schema.Oas30AnyOfSchema) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.visitNode(node);
    }

    /**
     * 
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindings(io.apicurio.datamodels.asyncapi.models.AaiServerBindings)
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiServerBindingsDefinition)
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindings(io.apicurio.datamodels.asyncapi.models.AaiOperationBindings)
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationBindingsDefinition)
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindings(io.apicurio.datamodels.asyncapi.models.AaiMessageBindings)
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageBindingsDefinition)
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindings(io.apicurio.datamodels.asyncapi.models.AaiChannelBindings)
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiChannelBindingsDefinition)
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageTraitDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageTraitDefinition)
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationTraitDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationTraitDefinition)
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
        this.visitNode(node);
    }

    constructor() {
    }
}
CombinedAllNodeVisitor["__class"] = "io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor";
CombinedAllNodeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];





import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';

